export default "__VITE_ASSET__COmnasUf__"